document.addEventListener('DOMContentLoaded', function(){
  // 重複初期化を防ぐガード
  if (window.__every_auto_swap_initialized) {
    return; // 既に初期化済みなら何もしない
  }
  window.__every_auto_swap_initialized = true;

  const INTERVAL_MS = 1800; // 画像切り替えの間隔（ミリ秒）
  const FADE_MS = 400;     // フェードイン/アウトの時間（ミリ秒）

  // 画像のソースURLを安全に取得するヘルパー関数
  function getImgSource(img){
    return img && (img.getAttribute('src') || img.src || img.getAttribute('data-src') || '');
  }

  // 商品カード内の追加画像を収集する関数
  function collectExtras(card){
    const extras = [];
    card.querySelectorAll('.auto-swap-extra-image').forEach(img=>{
      const src = getImgSource(img);
      if(src) extras.push(src);
    });
    return extras;
  }

  // 画像プリロードのためのキャッシュマップ
  const preloadCache = new Map();
  // 画像をプリロードする関数
  function preload(src){
    if(!src) return Promise.resolve(false); // srcがない場合は解決済みPromiseを返す
    if(preloadCache.has(src)) return preloadCache.get(src); // キャッシュにあればそれを返す
    const p = new Promise((resolve)=>{
      const i = new Image();
      i.onload = ()=>resolve(true); // 読み込み成功
      i.onerror = ()=>resolve(false); // 読み込み失敗
      i.src = src;
    });
    preloadCache.set(src, p); // キャッシュに保存
    return p;
  }

  // 全ての商品カードラッパー要素を取得
  const cards = Array.from(document.querySelectorAll('.card-wrapper.product-card-wrapper'));
  cards.forEach(cardWrapper => {
    // カード単位での重複バインドを防ぐガード
    if (cardWrapper.dataset.autoSwapBound === '1') {
      return; // 既にバインド済みならスキップ
    }
    cardWrapper.dataset.autoSwapBound = '1';

    // メイン画像要素とバッファ画像要素を取得
    const mainImg = cardWrapper.querySelector('.auto-swap-main-image');
    const bufferImg = cardWrapper.querySelector('.auto-swap-buffer-image');
    if(!mainImg || !bufferImg) return; // 必要な要素がなければ処理しない
    const extras = collectExtras(cardWrapper).slice(0, 2); // 追加画像を収集（最大2枚まで）
    if(extras.length === 0) return; // 追加画像がなければ処理しない
    // 元のメイン画像のURLを取得（data-original-srcがあればそれを使用）
    const original = mainImg.dataset.originalSrc || getImgSource(mainImg) || mainImg.src;

    // 元の画像と全ての追加画像をプリロード
    preload(original);
    extras.forEach(src=>preload(src));

    let idx = 0;
    // 画像を一定間隔で切り替えるインターバルを設定
    setInterval(async ()=>{
      idx = (idx + 1) % (extras.length + 1); // 次の画像のインデックスを計算
      const nextSrc = idx === 0 ? original : extras[idx-1]; // 次の画像URLを決定
      await preload(nextSrc); // 次の画像をプリロードして、読み込みが完了するまで待機

      // バッファ画像を使用して、ブランク表示なしでクロスフェード切替
      bufferImg.style.transition = `opacity ${FADE_MS}ms ease`; // バッファ画像のトランジションを設定
      bufferImg.src = nextSrc; // バッファ画像に次の画像をセット
      bufferImg.srcset = nextSrc; // srcsetも設定
      // 強制的にリフローさせてトランジションをトリガー
      void bufferImg.offsetWidth;
      bufferImg.style.opacity = 1; // バッファ画像をフェードイン

      setTimeout(()=>{
        // メイン画像にバッファ画像の内容をコピーし、バッファ画像を非表示にする
        try{
          mainImg.src = bufferImg.src;
          mainImg.srcset = bufferImg.srcset || mainImg.srcset; // srcsetもコピー
        }catch(e){/* エラーを無視 */}
        bufferImg.style.opacity = 0; // バッファ画像をフェードアウト
      }, FADE_MS); // フェードインと同じ時間で実行
    }, INTERVAL_MS);
  });
});


